<div
  *transloco="let t"
  class="fixed top-4 right-4 z-50 flex flex-col gap-2 pointer-events-none max-w-sm w-full px-4"
  aria-live="polite"
  aria-atomic="false">
  @for (item of toastSvc.toasts(); track item.id) {
    <div
      class="toast pointer-events-auto flex items-start gap-3 rounded-xl shadow-lg border px-4 py-3 text-sm bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
      [class]="
        item.type === 'success' ? 'border-green-300 dark:border-green-700' : 'border-red-300 dark:border-red-700'
      ">
      <fa-icon
        [icon]="item.type === 'success' ? faCircleCheck : faTriangleExclamation"
        class="mt-0.5 shrink-0"
        [class]="item.type === 'success' ? 'text-green-500 dark:text-green-400' : 'text-red-500 dark:text-red-400'"
        aria-hidden="true" />
      <span class="flex-1 leading-snug break-words">{{ item.message }}</span>
      <button
        (click)="toastSvc.dismiss(item.id)"
        [title]="t('toast.dismiss')"
        [attr.aria-label]="t('toast.dismiss')"
        class="shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors -mr-1 -mt-0.5">
        <fa-icon [icon]="faXmark" size="sm" aria-hidden="true" />
      </button>
    </div>
  }
</div>
